import { Link } from 'react-router-dom';
import type { AdminProfile } from '../auth';

export default function Home({ admin }: { admin: AdminProfile }) {
  return (
    <div className="container">
      <span className="eyebrow">Welcome</span>
      <h1 style={{ marginTop: 12 }}>{admin.full_name || admin.email}</h1>
      <p className="muted" style={{ marginBottom: 24 }}>
        Signed in as {admin.email} · role: {admin.role}
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 16 }}>
        <div className="card">
          <h2 style={{ marginTop: 0 }}>Tenants &amp; users</h2>
          <p className="muted" style={{ fontSize: 13 }}>
            Browse tenants, drill into users, inspect per-app data with custom or default renderer.
          </p>
          <p style={{ marginBottom: 0 }}>
            <Link to="/tenants"><strong>Open tenants →</strong></Link>
          </p>
        </div>

        <div className="card">
          <h2 style={{ marginTop: 0 }}>Seed</h2>
          <p className="muted" style={{ fontSize: 13 }}>
            Pre-provision a tenant or user. Use this for new product launches.
          </p>
          <p style={{ marginBottom: 0 }}>
            <Link to="/seed"><strong>Open seed →</strong></Link>
          </p>
        </div>

        <div className="card">
          <h2 style={{ marginTop: 0 }}>Admins</h2>
          <p className="muted" style={{ fontSize: 13 }}>
            Add or deactivate other Captomi employees who can access this admin app.
          </p>
          <p style={{ marginBottom: 0 }}>
            <Link to="/admins"><strong>Manage admins →</strong></Link>
          </p>
        </div>

        <div className="card">
          <h2 style={{ marginTop: 0 }}>Audit log</h2>
          <p className="muted" style={{ fontSize: 13 }}>
            Every admin action with filters by admin, action, and date range.
          </p>
          <p style={{ marginBottom: 0 }}>
            <Link to="/audit"><strong>View audit log →</strong></Link>
          </p>
        </div>
      </div>
    </div>
  );
}
